import { Reveal } from "./Reveal";
import { PHONE_DISPLAY, PHONE_TEL } from "@/lib/campaign";
import { track } from "@/lib/track";

export const HowItWorks = ({ variant }) => {
  const steps = [
    {
      title: "Learn what to expect",
      body: "Review the visit details and choose the appropriate visit for your concerns.",
    },
    {
      title: "Request your times",
      body: (
        <>
          Use the guide to pick the right visit, then request your top two appointment times
          online &mdash; the office will confirm one with you &mdash; or call{" "}
          <a
            data-testid="how-it-works-call-link"
            href={PHONE_TEL} data-call-location="how_it_works"
            onClick={() => track(variant, "call_click")}
            className="font-semibold text-[var(--brand-navy)] underline decoration-[var(--brand-gold)] decoration-2 underline-offset-4"
          >
            {PHONE_DISPLAY}
          </a>{" "}
          and the office will arrange it for you.
        </>
      ),
    },
    {
      title: "Meet with Dr. Crosson",
      body: "Spend your visit reviewing your concerns and discussing next steps together.",
    },
  ];
  return (
    <section data-testid="how-it-works-section" className="py-16 sm:py-24 bg-white border-y border-[var(--brand-gold-soft)]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <Reveal>
          <h2 className="font-serif-brand text-3xl sm:text-4xl font-medium text-[var(--brand-navy)]">
            How it works
          </h2>
        </Reveal>
        <div className="mt-10 grid md:grid-cols-3 gap-8">
          {steps.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.12}>
              <div className="relative pl-14">
                <span
                  className="absolute left-0 top-0 h-10 w-10 flex items-center justify-center border-2 border-[var(--brand-gold)] font-serif-brand text-xl font-semibold text-[var(--brand-navy)]"
                  aria-hidden="true"
                >
                  {i + 1}
                </span>
                <h3 className="font-serif-brand text-xl font-medium text-[var(--brand-navy)]">{s.title}</h3>
                <p className="mt-2 text-base leading-relaxed">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
